import { useCallback } from 'react';
import { TranslationKey } from 'core/models/translations.model';
import {
  InternationalizationBackendNameSpace,
  InternationalizationNameSpace,
} from 'core/models/internationalization-namespace';
import { useTranslation } from 'react-i18next';

type InterpolationValues = Record<string, string | number>;

const useTranslationWrapper = (
  namespaces: InternationalizationNameSpace | InternationalizationNameSpace[] | InternationalizationBackendNameSpace
) => {
  const { t } = useTranslation(namespaces, { useSuspense: false });
  const translate = useCallback(
    (key: TranslationKey, values?: InterpolationValues): string => t(key as string, values) as string,
    [t]
  );
  return { t: translate };
};
export { useTranslationWrapper };
